module.exports = __webpack_public_path__ + "img/article4-1.913ca2fd.jpg";